export default __webpack_public_path__ + "static/media/cat.077086a0.png";